import Box from '@mui/material/Box';
import { AnalyzeAudienceProvider } from 'client/modules/Analyze/AnalyzeAudienceContext';
import AnalyzeSubNav from 'client/modules/Analyze/AnalyzeSubNav';
import AnalyzeTitle from 'client/modules/Analyze/components/AnalyzeTitle';
import SecondaryNavTabs from 'client/modules/Surveys/pages/DashboardPage/SecondaryNavTabs';
import { fetchSurveys } from 'client/modules/Surveys/SurveyActions';
import { getSurveys } from 'client/modules/Surveys/SurveyReducer';
import Layout from 'components/Layout/Layout';
import React from 'react';
import { Outlet, useLoaderData, useParams } from 'react-router-dom';

const styles = {
  root: {
    display: 'flex',
    maxWidth: 1280,
    width: '100%',
    alignSelf: 'center',
    mb: 4,
    flexDirection: 'column',
  },
};

function AnalyzeLayout() {
  const { id: surveyId } = useParams();
  const surveys = useLoaderData();
  const survey = surveys?.find(s => s.id === surveyId);

  return (
    <Layout secondaryNav={<SecondaryNavTabs survey={surveyId} />}>
      <AnalyzeTitle />
      <Box sx={styles.root}>
        <AnalyzeSubNav />
        {survey ? (
          <AnalyzeAudienceProvider survey={survey}>
            <Outlet context={{ survey }} />
          </AnalyzeAudienceProvider>
        ) : (
          <Outlet context={{ survey }} />
        )}
      </Box>
    </Layout>
  );
}

AnalyzeLayout.loader =
  ({ getState, dispatch }) =>
  () => {
    const state = getState();
    const surveys = getSurveys(state);
    if (surveys?.length > 0) {
      return surveys;
    }
    return dispatch(fetchSurveys());
  };

export default AnalyzeLayout;
